"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _config = _interopRequireDefault(require("../config/config"));
var _postboxTableBodyHelper = require("../../common/features/PostBox/postboxTableBodyHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function getPostboxDocuments() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/documents"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function initDownloadPostboxDocument(documentId, cb) {
  var url = "".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/documents/").concat(documentId, "?filenameEncoding=").concat((0, _postboxTableBodyHelper.filenameEncoding)());
  _RestHelper.default.downloadContentWithPost(documentId, url, [], cb);
}
var _default = exports.default = {
  initDownloadPostboxDocument: initDownloadPostboxDocument,
  getPostboxDocuments: getPostboxDocuments
};